import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Skeleton } from '../components/ui/skeleton';
import { ChevronRight, ArrowRight, Calendar } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function News() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/news?limit=20`)
      .then(r => setArticles(r.data.articles || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-transition">
      <section className="py-10 sm:py-14" style={{ background: 'var(--surface-2)' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
            <Link to="/" className="hover:text-[var(--brand-navy)]">Home</Link>
            <ChevronRight className="w-3.5 h-3.5" /><span>News & Case Studies</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight" style={{ fontFamily: 'Space Grotesk', color: 'var(--brand-navy)' }}>News & Case Studies</h1>
          <p className="text-muted-foreground mt-1">Project highlights, product updates, and industry insights</p>
        </div>
      </section>

      <section className="py-8" style={{ background: 'var(--surface-0)' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1,2,3].map(i => <Card key={i}><CardContent className="p-5"><Skeleton className="h-40 mb-3" /><Skeleton className="h-4 w-3/4 mb-2" /><Skeleton className="h-3 w-full" /></CardContent></Card>)}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map(article => (
                <Link to={`/news/${article._id}`} key={article._id}>
                  <Card className="product-card-hover h-full" style={{ background: 'var(--surface-1)' }}>
                    {article.image_url && (
                      <div className="h-48 overflow-hidden rounded-t-lg">
                        <img src={article.image_url} alt={article.title} className="w-full h-full object-cover transition-transform hover:scale-105" loading="lazy" />
                      </div>
                    )}
                    <CardContent className="p-5">
                      <div className="flex items-center gap-2 mb-2">
                        <Badge variant="secondary" className="text-xs">{article.category === 'case-study' ? 'Case Study' : 'News'}</Badge>
                        {article.published_at && (
                          <span className="text-xs text-muted-foreground flex items-center gap-1">
                            <Calendar className="w-3 h-3" />
                            {new Date(article.published_at).toLocaleDateString()}
                          </span>
                        )}
                      </div>
                      <h3 className="font-semibold text-base mb-2 line-clamp-2" style={{ fontFamily: 'Space Grotesk', color: 'var(--brand-navy)' }}>{article.title}</h3>
                      <p className="text-sm text-muted-foreground line-clamp-3 mb-3">{article.excerpt}</p>
                      <div className="flex items-center gap-1 text-sm font-medium" style={{ color: 'var(--brand-teal)' }}>Read More <ArrowRight className="w-3.5 h-3.5" /></div>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
